import React, { useEffect } from 'react';

import { Dialog, Toast } from 'inpock-ui-react';
import { useRecoilState } from 'recoil';

import { toastState } from '@/store/toast';
import { dialogState, initialDialogState } from '@/store';

export function GlobalComponents() {
  const [toast] = useRecoilState(toastState);
  const [dialog, setDialog] = useRecoilState(dialogState);

  const dialogOff = () => {
    setDialog(initialDialogState);
  };

  useEffect(() => {
    dialogOff();
  }, []);

  return (
    <>
      {dialog.visible && <Dialog dialog={dialog} onDialogOff={dialogOff} />}
      <Toast visible={toast.visible} message={toast.message} />
    </>
  );
}
